import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Waves, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Benvenuto, ${u.name}`);
      nav(u.role === "operator" ? "/cambio" : "/");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  const quick = (em) => { setEmail(em); setPassword(em.includes("visitavirtuale") ? "Cambio2026!" : "cambio123"); };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-[#0B2447] text-white p-12 relative overflow-hidden">
        <div className="absolute -right-24 -top-24 w-96 h-96 rounded-full bg-[#0EA5C4]/20 blur-3xl" />
        <div className="absolute -left-16 bottom-10 w-80 h-80 rounded-full bg-[#0EA5C4]/10 blur-3xl" />
        <div className="flex items-center gap-3 relative">
          <div className="w-11 h-11 rounded-xl bg-[#0EA5C4] flex items-center justify-center"><Waves size={24} /></div>
          <span className="font-display font-extrabold text-xl">CambioBiancheria.it</span>
        </div>
        <div className="relative">
          <h1 className="font-display text-5xl font-extrabold leading-tight">Porta lo sporco.<br /><span className="text-[#0EA5C4]">Ritira il pulito.</span></h1>
          <p className="text-white/60 mt-5 max-w-md">Piattaforma gestionale del network. Gestisci clienti, cambi, dotazioni, cauzioni e pool biancheria — al banco in pochi secondi.</p>
        </div>
        <p className="text-white/40 text-sm relative">Network Management Platform · V1</p>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12 bg-[#F4F8FC]">
        <div className="w-full max-w-md">
          <div className="lg:hidden flex items-center gap-3 mb-8">
            <div className="w-10 h-10 rounded-xl bg-[#0B2447] flex items-center justify-center text-white"><Waves size={20} /></div>
            <span className="font-display font-extrabold text-lg text-[#0B2447]">CambioBiancheria.it</span>
          </div>
          <h2 className="font-display text-3xl font-extrabold text-[#0B2447]">Accedi</h2>
          <p className="text-slate-500 mt-1 mb-8">Entra nella piattaforma gestionale.</p>
          <form onSubmit={submit} className="space-y-5">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5 h-12" placeholder="nome@cambiobiancheria.it" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5 h-12" placeholder="••••••••" />
            </div>
            <Button type="submit" data-testid="login-submit" disabled={loading} className="w-full h-12 text-base bg-[#0B2447] hover:bg-[#14315f]">
              {loading ? <Loader2 className="animate-spin" size={18} /> : "Accedi"}
            </Button>
          </form>
          <div className="mt-8 border-t pt-5">
            <p className="text-xs text-slate-400 mb-2 font-semibold uppercase tracking-wide">Accessi demo</p>
            <div className="grid gap-2 text-sm">
              <button onClick={() => quick("visitavirtuale360@gmail.com")} className="text-left px-3 py-2 rounded-lg bg-white border hover:border-[#0EA5C4]">Super Admin Network</button>
              <button onClick={() => quick("admin.fiumicino@cambiobiancheria.it")} className="text-left px-3 py-2 rounded-lg bg-white border hover:border-[#0EA5C4]">Partner Admin · Fiumicino</button>
              <button onClick={() => quick("operatore.fiumicino@cambiobiancheria.it")} className="text-left px-3 py-2 rounded-lg bg-white border hover:border-[#0EA5C4]">Operatore · Fiumicino</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
